module.exports = __webpack_public_path__ + "static/img/illust-002-think.4190ecd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/illust-002-think.svg
// module id = SKZZ
// module chunks = 1